// extracted by mini-css-extract-plugin
export var container = "HeaderRss-module--container--TZL74";